module.exports = __webpack_public_path__ + "static/media/handout.0f831ae7.png";